import { FunctionComponent } from 'preact';
import debounce from 'lodash/debounce';
import { useEffect, useState } from 'preact/hooks';

const BuyingOptionsFloatingPagination: FunctionComponent<BuyingOptionsFloatingPaginationProps> = ({
    scrollLeft,
    scrollRight,
    syncScroll,
    disablePaginationButtonsCheck,
    nextButtonIsDisabled,
    prevButtonIsDisabled
}) => {
    const [paginationIsVisible, setPaginationIsVisible] = useState(false);
    const [tableIsVisible, setTableIsVisible] = useState(false);

    const paginationObserver = new IntersectionObserver(([entry]) => {
        setPaginationIsVisible(entry.isIntersecting);
    });

    const tableObserver = new IntersectionObserver(([entry]) => {
        setTableIsVisible(entry.isIntersecting);
    });

    const setObservers = () => {
        const paginationContainers = document.querySelectorAll<HTMLElement>(
            '[data-buying-options-pagination]'
        );
        const tables = document.querySelectorAll<HTMLElement>('[data-table-normal-head]');
        const tableId = window.innerWidth < 768 ? 1 : 0;
        paginationObserver.observe(paginationContainers[tableId]);
        tableObserver.observe(tables[tableId]);
    };

    window.addEventListener('load', setObservers);
    window.addEventListener('resize', setObservers);

    useEffect(() => {
        // Listen for table scroll events
        const tableContainers = document.querySelectorAll<HTMLElement>(
            '[data-buying-options-container]'
        );
        tableContainers.forEach(table => {
            table.addEventListener('scroll', debounce(disablePaginationButtonsCheck, 100));
        });
        tableContainers.forEach(table => {
            table.addEventListener('scroll', e => {
                syncScroll(e.target);
            });
        });
    }, []);

    return (
        <div
            class={`buying-options__pagination buying-options__pagination--floating ${
                !paginationIsVisible && tableIsVisible ? 'd-flex' : ''
            }`}
        >
            <button
                class={`buying-options__pagination-button prev btn btn-primary ${
                    prevButtonIsDisabled ? 'disabled' : ''
                }`}
                disabled={prevButtonIsDisabled}
                aria-disabled={prevButtonIsDisabled}
                onClick={() => {
                    scrollLeft();
                }}
            >
                <i
                    class="buying-options__pagination-chevron chevron-left d-inline-block mr-2"
                    aria-hidden="true"
                ></i>
                <span class="sr-only">Previous Size</span>
            </button>
            <button
                class={`buying-options__pagination-button next btn btn-primary ${
                    nextButtonIsDisabled ? 'disabled' : ''
                }`}
                disabled={nextButtonIsDisabled}
                aria-disabled={nextButtonIsDisabled}
                onClick={() => {
                    scrollRight();
                }}
            >
                <span class="sr-only">Next Size</span>
                <i
                    class="buying-options__pagination-chevron d-inline-block ml-2"
                    aria-hidden="true"
                ></i>
            </button>
        </div>
    );
};

interface BuyingOptionsFloatingPaginationProps {
    scrollLeft: () => void;
    scrollRight: () => void;
    syncScroll: (e: EventTarget | null) => void;
    disablePaginationButtonsCheck: () => void;
    nextButtonIsDisabled: boolean;
    prevButtonIsDisabled: boolean;
}

export default BuyingOptionsFloatingPagination;
